import CancelIcon from "@mui/icons-material/Cancel"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import licenseService from "services/licenseService"
import { updateLicense } from "slices/licenseSlice"
import { hiabColors } from "theme"
import type { ILicense } from "types/licenseTypes"

type Props = {
  license: ILicense
}

export function CancelLicenseDialog({ license }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const handleClickCancelLicenseGroup = () => {
    setIsLoading(true)

    licenseService
      .cancelLicense(license.id)
      .then((canceledLicense) => {
        dispatch(updateLicense(canceledLicense))
        setIsLoading(false)
        handleClose()
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <CancelIcon sx={{ marginRight: 1 }} />
        Cancel License
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>{"Cancel User License"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {"Are you sure you want to cancel the user license?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Box sx={{ m: 1, position: "relative" }}>
            <Button
              variant="contained"
              onClick={handleClickCancelLicenseGroup}
              disabled={isLoading}
              sx={{ backgroundColor: hiabColors.redPrimary }}
            >
              Confirm
            </Button>
            {isLoading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  )
}
